import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Block, H1, ContentHolder } from "commons";

import { hasAdviser } from "../../helpers/ContactHelpers";
import { ContactBlock } from "./ContactBlock";

export function Contacts({ adviser }) {
    const getAdviserBlock = adviser => (
        <ContactBlock
            title="Contacting your adviser"
            contact={`${adviser.forename} ${adviser.surname}`}
            email={adviser.emailAddress}
            phone={adviser.phoneNumber}
            addressLines={[
                adviser.addressLine1,
                adviser.addressLine2,
                adviser.addressLine3,
                adviser.addressLine4,
                adviser.city,
                adviser.postcode
            ]}
            support=""
        />
    );

    const getNucleusBlock = () => (
        <ContactBlock
            title="Contacting Nucleus"
            contact="Nucleus Financial Ltd."
            email="client.relations@nucleusfinancial.com"
            phone="0131 226 9535"
            livechat="Start live chat"
            addressLines={["Nucleus HQ", "Greenside", "12 Blenheim Place", "Edinburgh", "EH7 5JH"]}
            support="Support services are available from 8.30am to 5.30pm Monday to Friday (excluding bank holidays)"
        />
    );

    const adviserVerify = hasAdviser(adviser) ? adviser : null;

    return (
        <ContentHolder data-testid="contact-details">
            <H1>Contact us</H1>
            <Block>
                <FlexList>
                    {adviserVerify && (
                        <Fragment>
                            {getAdviserBlock(adviserVerify)}
                            <Separator />
                        </Fragment>
                    )}
                    {getNucleusBlock()}
                </FlexList>
            </Block>
        </ContentHolder>
    );
}

const FlexList = styled.ul`
    display: flex;
    list-style-type: none;

    @media (max-width: ${props => props.theme.maxWidth}) {
        flex-direction: column;
    }
`;

const Separator = styled.li`
    width: 2px;
    margin: 6px 0;
    background: ${props => props.theme.primary};
`;

Contacts.propTypes = {
    adviser: PropTypes.shape({
        adviserId: PropTypes.number,
        adviserOutletId: PropTypes.string,
        forename: PropTypes.string,
        surname: PropTypes.string,
        emailAddress: PropTypes.string,
        phoneNumber: PropTypes.string,
        addressLine1: PropTypes.string,
        addressLine2: PropTypes.string,
        addressLine3: PropTypes.string,
        addressLine4: PropTypes.string,
        postcode: PropTypes.string,
        city: PropTypes.string
    })
};
